/**
 * Created by Raul.
 *
 * Agregar las rutas que se desean cargar, usando la carga asincrona, se deben aregar por componente.
 *
 *  @routesApp Arreglo de rutas de la aplicación.
 */
import {Routes} from '@angular/router';
import {AuthGuardAdmin} from './common.module/auth/auth-guard.admin.service';
import {IndexAdminComponent} from './main-admin.component/index-admin.component';


const routesApp: Routes = [
  {
    path: '',
    component: IndexAdminComponent,
    canActivate: [AuthGuardAdmin]
  },
  {
    path: 'log-users',
    loadChildren: './admin.log-users.module/log-users.module#LogUsersModule',
    canActivate: [AuthGuardAdmin]
  },
  {
    path: 'adm_roles',
    loadChildren: './admin.roles.module/admin-roles.module#AdminRolesModule',
    data: {
      pageTitle: 'Administración de Roles'
    },
    canActivate: [AuthGuardAdmin]
  },
  {
    path: 'adm_usuarios',
    loadChildren: './admin.admin.module/admin-admin.module#AdminAdminModule',
    data: {
      pageTitle: 'Administración de Usuarios'
    },
    canActivate: [AuthGuardAdmin]
  },
  {
    path: 'adm_areas',
    loadChildren: './admin.areas.module/admin-areas.module#AdminAreasModule',
    data: {
      pageTitle: 'Áreas'
    },
    canActivate: [AuthGuardAdmin]
  },
  {
    path: 'admin-agenda',
    loadChildren: './admin.agenda.module/admin-agenda.module#AppAgendaModule',
    // canActivate: [AuthGuardAdmin]
  },
  {
    path: 'configuracion_chat',
    loadChildren: './admin.configuracion-chat.module/configuracion-chat.module#ConfiguracionChatModule',
    data: {
      pageTitle: 'Configuración del Chat'
    },
    canActivate: [AuthGuardAdmin]
  },
  {
    path: 'banners',
    loadChildren: './admin.banners.module/banners.module#BannersModule',
    canActivate: [AuthGuardAdmin]
  },
  {
    path: 'noticias',
    loadChildren: './admin.noticias.module/noticias.module#NoticiasModule',
    canActivate: [AuthGuardAdmin]
  },
  /*{
    path: 'catalogo_documentos',
    loadChildren: './admin.documentos.module/documentos.module#DocumentosModule',
    canActivate: [AuthGuardAdmin]
  },*/
  {
    path: 'catalogo_tramites',
    loadChildren: './admin.tramites.module/admin-tramites.module#AdminTramitesModule',
    canActivate: [AuthGuardAdmin]
  },
  {
    path: 'catalogo_categorias',
    loadChildren: './admin.categorias.module/categorias.module#CategoriasModule',
    canActivate: [AuthGuardAdmin]
  },
  {
    path: 'configuracion_general',
    loadChildren: './admin.configuracion-general.module/configuracion-general.module#ConfiguracionGeneralModule',
    canActivate: [AuthGuardAdmin]
  },
  {
    path: 'configuracion_tarjeta',
    loadChildren: './admin.configuracion-tarjeta.module/configuracion-tarjeta.module#ConfiguracionTarjetaModule',
    canActivate: [AuthGuardAdmin]
  },
  {
    path: 'bitacora',
    loadChildren: './admin.bitacora.module/bitacora.module#BitacoraModule',
    canActivate: [AuthGuardAdmin]
  },
  {
    path: 'cancelacion',
    loadChildren: './admin.cancelacion-solicitud.module/admin-cancelacion-solicitudes.module#AdminCancelacionSolicitudesModule',
    canActivate: [AuthGuardAdmin]
  },

  {
    path: 'dashboard',
    loadChildren: './admin.dashboard.module/dashboard.module#DashboardModule',
    canActivate: [AuthGuardAdmin]
  },
  {
    path: 'asignacion-pagos',
    loadChildren: './admin.asignacion-pagos.module/admin-asignacion-pagos-module#AdminAsignacionPagosModule',
    canActivate: [AuthGuardAdmin]
  },
  {
    path: 'ocupacion',
    loadChildren: './admin.ocupaciones.module/ocupacion.module#OcupacionModule'
  },
  {
    path: 'bpm_tramites',
    loadChildren: './admin.bpm.module/adm.bpm.module#AdmBpmModule',
    canActivate: [AuthGuardAdmin]
  },
  {
    path: 'motivos_rechazo',
    loadChildren: './admin.motivos-rechazo.module/motivos-rechazo.module#MotivosRechazoModule',
    canActivate: [AuthGuardAdmin]
  },
  {
    path: 'bpm_tramites_ejecucion',
    loadChildren: './admin.bpmflujo.module/adm.bpmflujo.module#AdmBpmFlujoModule',
    // canActivate: [AuthGuardPortal]
  },
  {
    path: 'cursos',
    loadChildren: './admin.cursos.module/cursos.module#CursosModule',
    data: {
      pageTitle: 'Catálogo de cursos'
    },
    canActivate: [AuthGuardAdmin]
  },
  {
    path: 'bandeja_entrada',
    loadChildren: './admin.index.module/admin-index.module#AdminIndexModule',
    data: {
      pageTitle: 'Bandeja de entrada'
    },
    canActivate: [AuthGuardAdmin]
  },
  {
    path: 'control-acceso',
    loadChildren: './admin.control-acceso.module/control-acceso.module#ControlAccesoModule',
    data: {
      pageTitle: 'Control de Acceso'
    },
     canActivate: [AuthGuardAdmin]
  },
  {
    path: 'zonas-aiq',
    loadChildren: './admin.zonas-aiq.module/zonas-aiq.module#ZonasAIQModule',
    data: {
      pageTitle: 'Zonas AIQ'
    },
    canActivate: [AuthGuardAdmin]
  },
  {
    path: 'color-tarjeta',
    loadChildren: './admin.color-tarjeta.module/color-tarjeta.module#ColorTarjetaModule',
    data: {
      pageTitle: 'Colores'
    },
    canActivate: [AuthGuardAdmin]
  },
  {
    path: 'cnf-folio',
    loadChildren: './admin.cnf-folio.module/cnf-folio.module#CnfFolioModule',
    data: {
      pageTitle: 'Folios'
    },
    canActivate: [AuthGuardAdmin]
  },
  {
    path: 'bitacora-ca',
    loadChildren: './admin.bitacora-ca.module/bitacora-ca.module#BitacoraCaModule',
    data: {
      pageTitle: 'Bitácora CA'
    },
    canActivate: [AuthGuardAdmin]
  },
  {
    path: 'registro-visitantes',
    loadChildren: './admin.registro-visitantes.module/registro-visitantes.module#RegistroVisitantesModule',
    data: {
      pageTitle: 'Visitantes'
    },
    canActivate: [AuthGuardAdmin]
  },
  {
    path: 'carga_masiva_tias',
    loadChildren: './admin.carga-masiva-tias.module/carga-masiva-tias.module#CargaMasivaTiasModule',
    canActivate: [AuthGuardAdmin]
  },
  {
    path: 'control-tarjetas',
    loadChildren: './admin.control-tarjetas.module/control-tarjetas.module#ControlTarjetasModule',
    data: {
      pageTitle: 'Control de tarjetas'
    },
    canActivate: [AuthGuardAdmin]
  },
  {
    path: 'reportes',
    loadChildren: './admin.reportes.module/admin-reportes.module#AdminReportesModule',
    data: {
      pageTitle: 'Reportes'
    },
  },
   // canActivate: [AuthGuardAdmin]
  {
    path: 'catalogo_resolutivos',
    loadChildren: './admin.resolutivosplantillas.module/plantresol.module#PlantResolModule',
    canActivate: [AuthGuardAdmin]
  },
  {
    path: 'catalogo_seccionresolutivos',
    loadChildren: './admin.seccionresolutivosplantillas.module/plantresolsecc.module#PlantResolSeccModule',
    canActivate: [AuthGuardAdmin]
  },
  {
    path: 'catalogo_etiqresolutivos',
    loadChildren: './admin.etiqresolutivosplantillas.module/plantresoletiq.module#PlantResolEtiqModule',
    canActivate: [AuthGuardAdmin]
  },
  {
    path: 'persona-boletinada',
    loadChildren: './admin.persona-boletinada.module/persona-boletinada.module#PersonaBoletinadaModule',
    canActivate: [AuthGuardAdmin]
  }
];

export const AdminRoutesModules = [...routesApp];
